<template>
  <el-scrollbar>
    <div class="app">
      <h4>员工信息：</h4>
      <el-form label-width="140px" class="bordered-container">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名：">
              <el-input v-model="employeeRegular.employeeName" style="width: 100%" disabled/>
            </el-form-item>
            <el-form-item label="职位：">
              <el-input v-model="employeeRegular.positionId" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工号：">
              <el-input v-model="employeeRegular.employeeNo" style="width: 100%" disabled/>
            </el-form-item>
            <el-form-item label="员工类型：">
              <el-select v-model="employeeRegular.employeeType" style="width: 100%" disabled>
                <el-option v-for="item in empTypeList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="部门：">
              <el-cascader style="width: 100%"
                           v-model="employeeRegular.departmentId"
                           :show-all-levels="false"
                           :options="departmentList"
                           disabled
                           :props="CascaderProp" ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职日期：">
              <el-input v-model="employeeRegular.entryDate" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划转正日期：">
              <el-input v-model="employeeRegular.probationEndDate" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h4>转正办理：</h4>
      <el-col class="bordered-container">
        <el-form label-width="140px">
          <el-row v-if="employeeRegular.employeeType==='contractor'">
            <el-col :span="24">
              <el-form-item label="转为正式工：">
                <el-switch v-model="employeeRegular.to_regular"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="转正日期：" required>
                <el-date-picker v-model="regularDate" placeholder="选择日期" style="width: 100%" value-format="YYYY-MM-DD" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input v-model="remark" style="width: 100%" :autosize="{ minRows: 5, maxRows: 8 }" type="textarea"/>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="附件：">
                <el-row>
                  <FrameItem v-model="file_id" :item="uploadObj"></FrameItem>
                </el-row>
              </el-form-item>

              <el-row v-for="(file, index) in fileList" :key="file.uid" style="margin-left: 140px;">
                <el-col :span="12">
                  <span>{{ index + 1 }}. </span>
                  <el-button type="text" @click="previewFile(file)">{{ file.name }}</el-button>
                </el-col>
                <el-col :span="12" class="file-actions">
                  <el-button type="text" @click="startPage(file)">
                    <i class="el-icon-view"></i> 预览
                  </el-button>
                  <el-button type="text" @click="downloadPage(file)">
                    <i class="el-icon-download"></i> 下载
                  </el-button>
                  <el-button type="text" style="color: red;" @click="deleteFile(file)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="">
                <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="">
                <FrameItem v-model="attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj"></FrameItem>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
      <h4>转正薪资：</h4>
      <el-row class="bordered-container">
        <el-col :span="12">
          <el-form label-width="140px">
            <h4 style="margin:0 0 15px 140px">转正前：</h4>
            <el-form-item label="薪资类型：">
              <el-select v-model="beforeRegular.salaryType" style="width: 100%" disabled>
                <el-option v-for="item in salaryTypeList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="薪资(底薪)：">
              <el-input v-model="beforeRegular.basicSalary" style="width: 100%" disabled></el-input>
            </el-form-item>
            <el-form-item label="标准津贴：">
              <el-input v-model="beforeRegular.allowance" style="width: 100%" disabled></el-input>
            </el-form-item>
            <el-form-item label="标准补贴：">
              <el-input v-model="beforeRegular.subsidy" style="width: 100%" disabled></el-input>
            </el-form-item>
            <el-form-item label="补贴选项：">
              <el-checkbox v-model="beforeRegular.subsidyOption" label="自定义补贴" disabled/>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="beforeRegular.carSubsidy" label="车补" disabled/>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="beforeRegular.houseSubsidy" label="房补" disabled/>
            </el-form-item>
            <el-form-item>
              <el-checkbox label="在职奖" v-model="beforeRegular.inServiceAward" disabled/>
            </el-form-item>
            <el-form-item>
              <el-checkbox label="全勤奖" v-model="beforeRegular.fullAttendanceAward" disabled/>
            </el-form-item>
            <el-form-item>
              <el-checkbox label="工龄奖" v-model="beforeRegular.workingYearsAward" disabled/>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <h4 style="margin:0 0 15px 140px">转正后：</h4>
          <el-form label-width="140px">
            <el-form-item label="薪资类型：">
              <el-select v-model="afterRegular.afterSalaryType" style="width: 100%" disabled>
                <el-option v-for="item in salaryTypeList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="薪资(底薪)：" required>
              <el-input v-model="afterRegular.afterBasicSalary" style="width: 100%" :precision="2" step="1000" type="number"></el-input>
            </el-form-item>
            <el-form-item label="标准津贴：" required>
              <el-input v-model="afterRegular.afterAllowance" :precision="2" step="1000" style="width: 100%" type="number"></el-input>
            </el-form-item>
            <el-form-item label="标准补贴：" required>
              <el-input v-model="afterRegular.afterSubsidy" :precision="2" step="1000" style="width: 100%" type="number"></el-input>
            </el-form-item>
            <el-form-item label="补贴选项：">
              <el-checkbox v-model="afterRegular.afterSubsidyOption" @click="afterSubsidyOptionChange"
                           label="自定义补贴"/>
            </el-form-item>
            <div>
              <el-form-item>
                <el-checkbox v-model="afterRegular.afterCarSubsidy" label="车补"
                             :disabled="!afterRegular.afterSubsidyOption"/>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="afterRegular.afterHouseSubsidy" label="房补"
                             :disabled="!afterRegular.afterSubsidyOption"/>
              </el-form-item>
              <el-form-item>
                <el-checkbox label="在职奖" v-model="afterRegular.afterInServiceAward"
                             :disabled="!afterRegular.afterSubsidyOption"/>
              </el-form-item>
              <el-form-item>
                <el-checkbox label="全勤奖" v-model="afterRegular.afterFullAttendanceAward"
                             :disabled="!afterRegular.afterSubsidyOption"/>
              </el-form-item>
              <el-form-item>
                <el-checkbox label="工龄奖" v-model="afterRegular.afterWorkingYearsAward"
                             :disabled="!afterRegular.afterSubsidyOption"/>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <div style="text-align: center">
        <el-button type="primary" @click="saveButton">保存</el-button>
      </div>

    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisibleTwo" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'
// import PrcPdf from "@/views/applications/prc/PrcPdf.vue";

export default {
  name: "EmployeeRegularProcessApply",
  // components: {PrcPdf},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      employeeRegular: {
        employeeName: '',
        employeeNo: '',
        positionId: '',
        departmentId: '',
        employeeType: '',
        entryDate: '',
        probationEndDate: '',
      },
      beforeRegular: {
        salaryType: '',
        basicSalary: '',
        allowance: '',
        subsidy: '',
        subsidyOption: '',
        carSubsidy: '',
        houseSubsidy: '',
        inServiceAward: '',
        fullAttendanceAward: '',
        workingYearsAward: '',
      },
      afterRegular: {
        afterSalaryType: '',
        afterBasicSalary: '',
        afterAllowance: '',
        afterSubsidy: '',
        afterSubsidyOption: false,
        afterCarSubsidy: '',
        afterHouseSubsidy: '',
        afterInServiceAward: '',
        afterFullAttendanceAward: '',
        afterWorkingYearsAward: '',
      },
      remark: '',
      regularDate: '',
      fileData: {},
      fileDataList: [],
      positionList: [],
      empTypeList: [],
      fileList: [],
      salaryTypeList: [],
      departmentList: [],
      file_id: [],
      CascaderProp: {
        emitPath: true,
        value: 'id',
        label: 'name'
      },
      dialogVisibleTwo:false,
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj:{
        component: 'image_upload',
        limit: 1,
      },
      attach_photo_id:'',
      attach_photo_id_obj:[]
    }
  },

  methods: {
    async fileChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.file_id = ''
        return
      }
      this.file_id = ids;
    },
    async afterSubsidyOptionChange() {
      if (this.afterRegular.afterSubsidyOption) {
        this.afterRegular.afterCarSubsidy = false
        this.afterRegular.afterHouseSubsidy = false
        this.afterRegular.afterInServiceAward = false
        this.afterRegular.afterFullAttendanceAward = false
        this.afterRegular.afterWorkingYearsAward = false
      }
    },
    async saveButton() {
      if (this.regularDate == null) {
        this.$message.error("请选择转正日期");
        return;
      }
      if (this.afterRegular.afterBasicSalary == null || Number(this.afterRegular.afterBasicSalary) <= 0 || this.afterRegular.afterBasicSalary === '') {
        this.$message.error("请填写正确的薪资");
        return;
      }
      if (this.afterRegular.afterAllowance == null || Number(this.afterRegular.afterAllowance) < 0 || this.afterRegular.afterAllowance === '') {
        this.$message.error("请填写正确的标准津贴");
        return;
      }
      if (this.afterRegular.afterSubsidy == null || Number(this.afterRegular.afterSubsidy) < 0 || this.afterRegular.afterSubsidy === '') {
        this.$message.error("请填写正确的标准补贴");
        return;
      }
      let params = {
        id: this.parentData.id,
        regularDate: this.regularDate,
        fileData: this.fileData,
        fileList: this.fileList,
        employeeRegular: this.employeeRegular,
        afterRegular: this.afterRegular,
        beforeRegular: this.beforeRegular,
        employeeName: this.employee_name,
        employeeNo: this.employee_no,
        remark: this.remark,
        file_id: this.file_id,
        attach_photo_id: this.attach_photo_id
      }
      await this.$http("employeeRegularProcessService.saveEmployeeRegularInfo", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      // console.log("this.beforeRegular",this.beforeRegular)
      if (params.id !== undefined) {
        let data = await this.$http("employeeRegularProcessService.getById", params);
        this.employeeRegular.employeeName = data.employee_name
        this.employeeRegular.employeeNo = data.employee_no
        this.employeeRegular.positionId = data.position_id
        this.employeeRegular.departmentId = data.department_ids
        this.employeeRegular.employeeType = data.employee_type
        this.employeeRegular.entryDate = data.entry_date
        this.employeeRegular.probationEndDate = data.probation_end_date
        this.beforeRegular.salaryType = data.salary_type_id
        this.beforeRegular.basicSalary = data.salary
        this.beforeRegular.allowance = data.salary_allowance
        this.beforeRegular.subsidy = data.salary_subsidy
        this.beforeRegular.subsidyOption = data.is_customization_subsidy
        this.beforeRegular.carSubsidy = data.salary_car
        this.beforeRegular.houseSubsidy = data.salary_house
        this.beforeRegular.inServiceAward = data.salary_on_job
        this.beforeRegular.fullAttendanceAward = data.salary_full_attendance
        this.beforeRegular.workingYearsAward = data.salary_work_year
        this.regularDate = data.probation_end_date
        this.afterRegular.afterSalaryType = data.salary_type_id
      }
    },
    async openCameraMain(){
      this.dialogVisibleTwo = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisibleTwo = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    startPage(item, itemData) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "prc/PrcPdf";
      windowObj.name = item.originalName.substring(0, item.originalName.length - 4);
      windowObj.parentData = {sys_file: item, itemData: itemData};
      windowObj.height = 1000 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1450 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
//下载文件
    downloadPage(item) {
      let url = item?.url;
      if (!url) {
        return
      }
      let name = item.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    handleUploadSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file.raw)
      });
      this.$message.success(`${file.name} 上传成功`);
    },
    previewFile(file) {
      this.$message.info(`预览文件：${file.name}`);
      // 这里可以实现打开文件预览的逻辑
    },
    handleUploadError(err, file) {
      this.$message.error(`${file.name} 上传失败`);
    },
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('只能上传 PDF 文件');
      }
      return isPDF;  // 如果不是 PDF 文件，返回 false 阻止上传
    },

    deleteFile(file) {
      this.fileList = this.fileList.filter(f => f.uid !== file.uid);
      this.$message.success(`${file.name} 已删除`);
    },
    async getDept() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
      console.log(this.departmentList + "部门列表")
    },
    async getOptions() {
      let data = await this.$http("employeeChangeRecordService.getAllOptions");
      this.positionList = data.position_options
      this.empTypeList = data.employee_type_options
      this.salaryTypeList = data.salary_type_options
    },
  },
  async created() {
    await this.getOptions();
    await this.getDept();
    await this.getData();// 在组件创建时获取数据
    await this.afterSubsidyOptionChange();
  },
}
</script>

<style scoped lang="less">

.bordered-container {
  border: 0.5px solid lightgrey !important;
  padding: 10px 60px 10px 0;
  width: 97%;
  margin: 10px;
}

.app {
  margin: 20px;
}

.upload-button {
  display: inline-block;
  margin-left: 10px;
}

.file-actions {
  text-align: right;
}
</style>
